import { LandingComponent } from './components/LandingComponent';

export const Events = () => {
  return (
    <>
      <LandingComponent />
    </>
  );
};
